<template>
  <div v-if="ToastOn" class="com_toast">
    <div class="centerposition com_toast_main">
      <div class="contentBox radius4">
        <div v-show="title" class="ToastOn_title" v-html="title"></div>
        <div class="contentMain">
            <slot name="content"></slot>
        </div>
      </div>
      <div class="footer">
        <span @click="closeFn" class="close">✕</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['title'],
    data: function () {
      return {
        ToastOn:false,
      }
    },
    created: function () {

    },
    mounted: function () {

    },
    methods: {
      closeFn:function(){
        this.ToastOn=false;
        this.$emit('closeCallback')
      },
      changeToastOn:function(flag){
        this.ToastOn=flag;
      }
    },
    components: {},
    computed: {},
  }
</script>

<style lang="scss">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/com_toast/index.vue